import { render, staticRenderFns } from "./InputDialog.vue?vue&type=template&id=bedf7b4c&"
import script from "./InputDialog.vue?vue&type=script&lang=js&"
export * from "./InputDialog.vue?vue&type=script&lang=js&"
import style0 from "./InputDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports